import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import imageCompression from 'browser-image-compression';
import { 
    Tabs, 
    Tab, 
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Button,
    Grid,
} from '@mui/material';
import { useAccesos } from '../contexts/AccesosContext';
function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}
function AddMedico({ handleNewMedico, editMedico }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [formData, setFormData] = useState({
        idMedico: 0,
        nombreMedico: '',
        telefono: '',
        direccion: '',
        correo: '',
        porcentajeDescuento: 0,
        celular: '',
        idCentroDeTrabajo: 1,
        idEspecialidad: 1,
        idMunicipio: 11,
        observaciones: '',
        valorHonorarios: 0,
        valorComision: 0,
        idTipoComision: 1,
        numeroColegiacion: '',
        fechaNacimiento: null,
        firma: '',
        sello: '',
        valorCita: 0,
        consultorio: 0,
        valorInterconsulta: 0,
        porcentajeDescuentoChm: 0,
        pinFirmaSello: 0,
        urlFoto: null,
        idApp: null,
        descripcionImgPagWeb:'',
        palabrasImgClavePagWeb:'',
        visitante: false, 

        
    });
    const fetchHorarios = async () => {
        if (!editMedico) return;
        try {
            const response = await fetch(`${server}/Horarios/${editMedico.idMedico}`);
            const data = await response.json();

            setHorarios(data.$values || []);
        } catch (error) {
            console.error('Error fetching horarios:', error);
        }
    };
    
    const fetchVacaciones = async () => {
        if (!editMedico) return;
        try {
            const response = await fetch(`${server}/Vacaciones/${editMedico.idMedico}`);
            const data = await response.json();
            setVacaciones(data.$values || []);
        } catch (error) {
            console.error('Error fetching vacaciones:', error);
        }
    };

    
   
    const cleanMedicoData = (data) => {
        const cleanData = {
            idMedico: data.idMedico || 0,
            nombreMedico: data.nombreMedico,
            ingresadoPor: editMedico ? data.ingresadoPor : user?.codigoUsuario || 'ADMIN',
            fechaIngreso: editMedico ? data.fechaIngreso : new Date().toISOString(),
            modificacion: editMedico ? 2 : 1,
            modificadoPor: editMedico ? user?.codigoUsuario : null,
            fechaModificacion: editMedico ? new Date().toISOString() : null,
            telefono: data.telefono || '',
            direccion: data.direccion || '',
            correo: data.correo || '',
            porcentajeDescuento: data.porcentajeDescuento || 0,
            celular: data.celular || '',
            idCentroDeTrabajo: data.idCentroDeTrabajo || 1,
            idEspecialidad: data.idEspecialidad || 1,
            idMunicipio: data.idMunicipio || 11,
            observaciones: data.observaciones || '',
            valorHonorarios: data.valorHonorarios || 0,
            valorComision: data.valorComision || 0,
            idTipoComision: data.idTipoComision || 1,
            numeroColegiacion: data.numeroColegiacion || '',
            fechaNacimiento: data.fechaNacimiento || null,
            firma: data.firma || '',
            sello: data.sello || '',
            valorCita: data.valorCita || 0,
            consultorio: data.consultorio || 0,
            valorInterconsulta: data.valorInterconsulta || 0,
            porcentajeDescuentoChm: data.porcentajeDescuentoChm || 0,
            pinFirmaSello: data.pinFirmaSello || 0,
            urlFoto: data.urlFoto || null,
            idApp: data.idApp || null,
            descripcionImgPagWeb: data.descripcionImgPagWeb || '',
            palabrasImgClavePagWeb: data.palabrasImgClavePagWeb || '',
            visitante: data.visitante || false,
      

        };
        return cleanData;
    };
    const [especialidades, setEspecialidades] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState(1);
    const [imagePreview, setImagePreview] = useState(null);
    const [urlImagen, setUrlImagen] = useState('');
    const [doctoresApp, setDoctores] = useState([]);
    const [tabValue, setTabValue] = useState(0);
    const [addHorarioDialog, setAddHorarioDialog] = useState(false);
    const [addVacacionDialog, setAddVacacionDialog] = useState(false);
    const [sucursales, setSucursales] = useState([]);
    const [horarioForm, setHorarioForm] = useState({
        id: 0,
        medicoId: editMedico?.idMedico || 0,
        diaSemana: 0,
        horaInicio: '00:00',
        horaFin: '00:00',
        idSucursal: 0,
        fechaVisita: null,
    });
    
    const [vacacionForm, setVacacionForm] = useState({
        id: 0,
        medicoId: editMedico?.idMedico || 0,
        fechaInicio: new Date().toISOString().split('T')[0],
        fechaFin: new Date().toISOString().split('T')[0]
    });
    const [horarios, setHorarios] = useState([]);
    const [vacaciones, setVacaciones] = useState([]);


    const [descripcionImgPagWeb, setDescripcionImgPagWeb] = useState('');
    const [palabrasImgClavePagWeb, setPalabrasImgClavePagWeb] = useState('');

    useEffect(() => {
        fetchEspecialidades();
        fetchMunicipios();
        fetchDoctores();
        fetchSucursales();

        if (editMedico) {
            console.log("EDIT MEDICO COMPLETO:", editMedico);
            console.log("IdApp que viene:", editMedico.IdApp);

            setFormData({
                ...editMedico,
                // Ensure IdApp is properly set for the select dropdown
                // idApp: editMedico.idApp || null
                //  idApp: editMedico.idApp?.codDoctor ?? editMedico.idApp ?? null
            });
            console.log(editMedico);
            setModificacion(2);
            fetchHorarios();
            fetchVacaciones();
            setDescripcionImgPagWeb;
            setPalabrasImgClavePagWeb;
            
            // Set image preview if urlFoto exists
            if (editMedico.urlFoto) {
                if (typeof editMedico.urlFoto === 'string') {
                    setImagePreview(editMedico.urlFoto);
                }
            }
        }
    }, [editMedico]);
    const fetchDoctores = async () => {
        try {
            const response = await fetch(`${server}/doctores/internos`);
            const data = await response.json();
            setDoctores(data.$values);
            console.log(data.$values);
            return data.$values;
        } catch (error) {
            console.error('Error al cargar doctores:', error);
            return [];
        }
    };
    const fetchEspecialidades = async () => {
        try {
            const response = await fetch(`${server}/MgMedicosEspecialidades/todas`);
            const data = await response.json();
            setEspecialidades(data.$values);
        } catch (error) {
            console.error('Error al cargar las especialidades:', error);
        }
    };

    const fetchMunicipios = async () => {
        try {
            const response = await fetch(`${server}/MgMunicipios`);
            const data = await response.json();
            setMunicipios(data.$values);
        } catch (error) {
            console.error('Error al cargar municipios:', error);
        }
    };


     const fetchSucursales = async () => {
        try {
            const response = await fetch(`${server}/MgSucursales`);
            const data = await response.json();
            setSucursales(data.$values);
        } catch (error) {
            console.error('Error al cargar sucursales:', error);
        }
    };

    // Funcion para comprimir la imagen
    const comprimirImagen = async (imagen) => {
        const opciones = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 1280,
            useWebWorker: true,
        };

        try {
            const imagenComprimida = await imageCompression(imagen, opciones);

        // extension original
        const extension = imagen.name.split('.').pop();
        const nuevoNombre = `${imagen.name.split('.')[0]}.${extension}`;

        //Crear un nuevo objeto File con nombre y extension correcta
        const archivoFinal = new File (
            [imagenComprimida],
            nuevoNombre,
            {
                type: imagen.type,
                lastModified: Date.now()
            }
        );
            return archivoFinal;
        } catch (error) {
            console.error('Error al comprimir imagen: ', error);
            return imagen;
        }
    };

    // Update the handleImageUpload function
const handleImageUpload = async (file) => {
    const archivoComprimido = await comprimirImagen(file);

    const username = '' + user.codigoUsuario + '';
    const formData = new FormData();
    formData.append('file', archivoComprimido);
    
    try {
        // Use different URL parameter for new vs existing doctors
        const medicoIdParam = editMedico ? `medicoId=${editMedico.idMedico}` : 'medicoId=0';
        const response = await fetch(`${server}/MgMedicoes/upload?usuario=${username}&${medicoIdParam}`, {
            method: 'POST',
            body: formData
        });
        
        if (response.ok) {
            const data = await response.json();
            // Update the formData state with the new image URL
            setFormData(prev => ({ ...prev, urlFoto: data.urlFoto }));
            
            // Set image preview
            if (data.urlFoto) {
                if (typeof data.urlFoto === 'string') {
                    setImagePreview(data.urlFoto);
                } else if (file instanceof Blob || file instanceof File) {
                    setImagePreview(URL.createObjectURL(file));
                }
            }
        } else {
            alert('Error al subir la imagen');
        }
    } catch (error) {
        console.error('Error:', error);
        alert('Error al subir la imagen');
    }
};
    const handleDeleteHorario = async (id) => {
        try {
            const username = '' + user.codigoUsuario + '/';
            console.log(username);
            const response = await fetch(`${server}/Horarios/${id}/${username}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
    console.log(response);
            if (response.ok) {
                await fetchHorarios();
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Horario eliminado correctamente'
                });
            } else {
                throw new Error('Error al eliminar el horario');
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message
            });
        }
    };
    
    const handleDeleteVacaciones = async (id) => {
        try {
            const username = '' + user.codigoUsuario + '/';
            const response = await fetch(`${server}/Vacaciones/${id}/${username}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (response.ok) {
                await fetchVacaciones();
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: 'Vacaciones eliminadas correctamente'
                });
            } else {
                throw new Error('Error al eliminar las vacaciones');
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message
            });
        }
    };
    
    const handleSaveVacacion = async () => {
        try {
            const response = await fetch(`${server}/Vacaciones`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    medicoId: editMedico.idMedico,
                    fechaInicio: vacacionForm.fechaInicio,
                    fechaFin: vacacionForm.fechaFin,
                    ingresadoPor: user.codigoUsuario
             
                })
            });
            console.log(JSON.stringify({
                medicoId: editMedico.idMedico,
                fechaInicio: vacacionForm.fechaInicio,
                fechaFin: vacacionForm.fechaFin,
                ingresadoPor: user.codigoUsuario
         
            }));
    console.log(response);
            if (response.ok) {
                fetchVacaciones();
                setAddVacacionDialog(false);
                setVacacionForm({
                    id: 0,
                    medicoId: editMedico.idMedico,
                    fechaInicio: new Date().toISOString().split('T')[0],
                    fechaFin: new Date().toISOString().split('T')[0]
                });
                Swal.fire('Éxito', 'Vacaciones agregadas correctamente', 'success');
            }
        } catch (error) {
            Swal.fire('Error', 'Error al agregar las vacaciones', 'error');
        }
    };
    // Add after existing handlers
const handleSaveHorario = async () => {
    
    if (!horarioForm.idSucursal) {
        Swal.fire('Atención', 'Debe seleccionar una sucursal', 'warning');
            return;
    }

     // Médico visitante: requiere fecha
    if (formData.visitante && !horarioForm.fechaVisita) {
        Swal.fire(
            'Atención',
            'Debe seleccionar una fecha de visita',
            'warning'
        );
        return;
    }

    // Médico normal: requiere día
    if (!formData.visitante &&
        (horarioForm.diaSemana === null ||
         horarioForm.diaSemana === undefined ||
         horarioForm.diaSemana === '')
    ) {
        Swal.fire(
            'Atención',
            'Debe seleccionar un día',
            'warning'
        );
        return;
    }

    try {
        const response = await fetch(`${server}/Horarios`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                medicoId: editMedico.idMedico,
                diaSemana: parseInt(horarioForm.diaSemana),
                fechaVisita: formData.visitante ? horarioForm.fechaVisita : null,
                horaInicio: horarioForm.horaInicio+':00',
                horaFin: horarioForm.horaFin+':00',
                ingresadoPor: user.codigoUsuario,
                idSucursal: horarioForm.idSucursal
            })
        });
  
        if (response.ok) {
            await fetchHorarios();
            setAddHorarioDialog(false);
            setHorarioForm({
                id: 0,
                medicoId: editMedico.idMedico,
                diaSemana: 0,
                horaInicio: '00:00',
                horaFin: '00:00',
                idSucursal: editMedico.idSucursal,
                fechaVisita: null
            });
            Swal.fire('Éxito', 'Horario agregado correctamente', 'success');
        } else {
            throw new Error('Error al guardar el horario');
        }
    } catch (error) {
        Swal.fire('Error', error.message, 'error');
    }
};
    const handleSubmit = async (e) => {
        e.preventDefault();

        const medicoData = {
            ...formData,
            ingresadoPor: editMedico ? formData.ingresadoPor : user?.codigoUsuario || 'ADMIN',
            modificadoPor: editMedico ? user?.codigoUsuario : null, idApp: formData.idApp,
          
        };

        try {
            const endpoint = editMedico
                ? `${server}/MgMedicoes/${editMedico.idMedico}`
                : `${server}/MgMedicoes`;
                const cleanedData = cleanMedicoData(formData);

            const response = await fetch(endpoint, {
                method: editMedico ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(cleanedData),
            });
            console.log(cleanedData);
            console.log(response);
            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Éxito',
                    text: `Médico ${editMedico ? 'actualizado' : 'agregado'} correctamente`,
                });
                
               
                    // Only clear data for new records, preserve for edit mode
                    setFormData({});
                    setImagePreview(null);
                    setHorarios([]);    
                    setVacaciones([]);
                
                
                handleNewMedico();
            }else {
                throw new Error('Error en la operación');
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message,
            });
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        if (type === 'checkbox') {
        setFormData(prev => ({ ...prev, [name]: checked }));
        // Handle numeric fields
        } else if (name === 'IdApp' || name === 'idEspecialidad' || name === 'idMunicipio') {
            const numericValue = value === '' ? null : parseInt(value, 10);
            setFormData(prev => ({
                ...prev,
                [name]: numericValue
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };
    
    return (
        <>
            <h2>{editMedico ? 'Editar Médico' : 'Nuevo Médico'}</h2>
            <form onSubmit={handleSubmit} className="form-horizontal form-label-left">
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align">
                        Nombre del Médico <span className="required">*</span>
                    </label>
                    <div className="col-md-6 col-sm-6">
                        <input
                            type="text"
                            name="nombreMedico"
                            required
                            className="form-control"
                            value={formData.nombreMedico || ''}
                            onChange={handleChange}
                        />
                    </div>
                <div className="col-md-3 col-sm-3 d-flex align-items-center" style={{ paddingLeft: '15px' }}>
                    <div className="form-check d-flex align-items-center" style={{ gap: '10px' }}>           
                        <input
                            type="checkbox"
                            name="visitante"
                            checked={formData.visitante || false}
                            onChange={handleChange}
                            style={{ width: '16px', height: '16px', cursor: 'pointer', marginTop: 0 }}
                            
                        />
                        <label className="col-form-label label-align" htmlFor="visitante" style={{ marginBottom: 0 }}> Médico Visitante</label>
                    </div>
                    </div> 
            </div>

                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align">
                        Especialidad
                    </label>
                    <div className="col-md-6 col-sm-6">
                        <select
                            name="idEspecialidad"
                            className="form-control"
                            value={formData.idEspecialidad || ''}
                            onChange={handleChange}
                            >
                            {especialidades.map(esp => (
                                <option key={esp.id} value={esp.id}>
                                    {esp.descripcion}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align">
                        Teléfono
                    </label>
                    <div className="col-md-6 col-sm-6">
                        <input
                            type="text"
                            name="telefono"
                            className="form-control"
                            value={formData.telefono || ''}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="item form-group">
    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="urlFoto">Imagen:</label>
    <div className="col-md-6 col-sm-6">
        <input
            type="file"
            id="urlFoto"
            className="form-control"
            accept="image/*"
            onChange={(e) => {
                if (e.target.files && e.target.files[0]) {
                    handleImageUpload(e.target.files[0]);
                }
            }}
        />
        {(imagePreview || formData.urlFoto) && (
            <div className="mt-2">
                <img
                    src={imagePreview || formData.urlFoto}
                    alt="Preview"
                    style={{ maxWidth: '200px', maxHeight: '200px' }}
                />
            </div>
        )}
        </div>
    </div>
     <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align">
                        Descripción Página Web <span className="required">*</span>
                    </label>
                    <div className="col-md-6 col-sm-6">
                        <input
                            type="text"
                            name="descripcionImgPagWeb"
                          
                            className="form-control"
                            value={formData.descripcionImgPagWeb || ''}
                           onChange={handleChange}
                        />
                    </div>
                </div>
           <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align">
                        Palabras clave <span className="required">*</span>
                    </label>
                    <div className="col-md-6 col-sm-6">
                        <input
                            type="text"
                            name="palabrasImgClavePagWeb"
                       
                            className="form-control"
                            value={formData.palabrasImgClavePagWeb || ''}
                            onChange={handleChange} 
                        />
                    </div>
                </div>
      {/* <Grid item xs={12} md={6}>
            <TextField label="Descripción Página Web" value={descripcionImgPagWeb} onChange={(e) => setDescripcionImgPagWeb(e.target.value)} fullWidth required />
        </Grid>
        <Grid item xs={12} md={6}>
            <TextField label="Palabras clave" value={palabrasImgClavePagWeb} onChange={(e) => setPalabrasImgClavePagWeb(e.target.value)} fullWidth required />
        </Grid> */}
                    <div className="item form-group">
                        <label className="col-form-label col-md-3 col-sm-3 label-align">
                            Doctor
                        </label>
                        <div className="col-md-6 col-sm-6">
                        <select
                            name="idApp"
                            className="form-control"
                            value={formData.idApp ? formData.idApp.toString() : ''}

                            onChange={(e) => {
                                const value = e.target.value ? parseInt(e.target.value, 10) : null;
                                setFormData(prev => ({...prev, idApp: value}));
                            }}
                        >
                            <option value="">Seleccione un doctor</option>
                            {doctoresApp.map(doc => (
                                <option key={doc.codDoctor} value={doc.codDoctor.toString()}>
                                    {doc.nombreDoctor}
                                </option>
                            ))}
                        </select>
                        </div>
                    </div>
                    <div className="item form-group">
                        <label className="col-form-label col-md-3 col-sm-3 label-align">
                            Dirección
                        </label>
                        <div className="col-md-6 col-sm-6">
                            <input
                                type="text"
                                name="direccion"
                                className="form-control"
                                value={formData.direccion || ''}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className="item form-group">
                        <label className="col-form-label col-md-3 col-sm-3 label-align">
                            Horarios y Vacaciones
                        </label>
                        <div className="col-md-6 col-sm-6">
    <div className="mt-4">
        <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)}>
            <Tab label="Horarios" />
            <Tab label="Vacaciones" />
        </Tabs>

        <TabPanel value={tabValue} index={0}>
            <div style={{ marginBottom: '1rem' }}>
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={() => setAddHorarioDialog(true)}
                >
                    Agregar Horario
                </Button>
            </div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{formData.visitante ? 'Fecha Visita' : 'Día'}</TableCell>
                            <TableCell>Hora Inicio</TableCell>
                            <TableCell>Hora Fin</TableCell>
                            <TableCell>Sucursal</TableCell>
                            <TableCell>Acciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {horarios.map((horario) => {

                        return (
                            <TableRow key={horario.id}>
                                <TableCell>
                                    {formData.visitante
                                        ? horario.fechaVisita
                                            ? new Date(horario.fechaVisita + 'T00:00:00').toLocaleDateString()
                                            : '-'
                                    : ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][horario.diaSemana]
                                    }
                                </TableCell>
                                <TableCell>{horario.horaInicio}</TableCell>
                                <TableCell>{horario.horaFin}</TableCell>
                                <TableCell>{horario.nombreSucursal}</TableCell>
                                <TableCell>
                                    <Button 
                                        color="error" 
                                        onClick={() => handleDeleteHorario(horario.id)}
                                    >
                                        Eliminar
                                    </Button>
                                </TableCell>
                            </TableRow>
                        );
})}
                    </TableBody>
                </Table>
            </TableContainer>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
            <div style={{ marginBottom: '1rem' }}>
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={() => setAddVacacionDialog(true)}
                >
                    Agregar Vacaciones
                </Button>
            </div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Fecha Inicio</TableCell>
                            <TableCell>Fecha Fin</TableCell>
                            <TableCell>Acciones</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {vacaciones.map((vacacion) => (
                            <TableRow key={vacacion.id}>
                                <TableCell>{new Date(vacacion.fechaInicio).toLocaleDateString()}</TableCell>
                                <TableCell>{new Date(vacacion.fechaFin).toLocaleDateString()}</TableCell>
                                <TableCell>
                                    <Button 
                                        color="error" 
                                        onClick={() => handleDeleteVacaciones(vacacion.id)}
                                    >
                                        Eliminar
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </TabPanel>

        {/* Dialog for Horarios */}
    <Dialog open={addHorarioDialog} onClose={() => setAddHorarioDialog(false)}>
        <DialogTitle>Agregar Horario</DialogTitle>
        <DialogContent>
             <FormControl fullWidth margin="normal">
                <InputLabel>Sucursal</InputLabel>
                <Select
                    value={horarioForm.idSucursal}
                    onChange={(e) => setHorarioForm({...horarioForm, idSucursal: e.target.value})}
                    label="Sucursal"
                >
                    {sucursales.map((sucursal) => (
                        <MenuItem key={sucursal.idSucursal} value={sucursal.idSucursal}>
                            {sucursal.nombreSucursal}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
                {/* 👇 Campo condicional según si es visitante */}
                {formData.visitante ? (
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Fecha de Visita"
                        type="date"
                        value={horarioForm.fechaVisita || ''}
                        onChange={(e) => setHorarioForm({...horarioForm, fechaVisita: e.target.value, diaSemana: null})}
                        InputLabelProps={{ shrink: true }}
                    />
                ) : (
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Día</InputLabel>
                        <Select
                            value={horarioForm.diaSemana}
                            onChange={(e) => setHorarioForm({...horarioForm, diaSemana: e.target.value})}
                        >
                            {['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
                                .map((dia, index) => (
                                    <MenuItem key={index} value={index}>{dia}</MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                )}
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Hora Inicio"
                        type="time"
                        value={horarioForm.horaInicio}
                        onChange={(e) => setHorarioForm({...horarioForm, horaInicio: e.target.value})}
                        InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Hora Fin"
                        type="time"
                        value={horarioForm.horaFin}
                        onChange={(e) => setHorarioForm({...horarioForm, horaFin: e.target.value})}
                        InputLabelProps={{ shrink: true }}
                    />
                    
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAddHorarioDialog(false)}>Cancelar</Button>
                    <Button onClick={handleSaveHorario} color="primary">
                        Guardar
                    </Button>
                </DialogActions>
        </Dialog>

    {/* Dialog for Vacaciones */}
    <Dialog open={addVacacionDialog} onClose={() => setAddVacacionDialog(false)}>
        <DialogTitle>Agregar Vacaciones</DialogTitle>
        <DialogContent>
            <TextField
                fullWidth
                margin="normal"
                label="Fecha Inicio"
                type="date"
                value={vacacionForm.fechaInicio}
                onChange={(e) => setVacacionForm({...vacacionForm, fechaInicio: e.target.value})}
                InputLabelProps={{ shrink: true }}
            />
            <TextField
                fullWidth
                margin="normal"
                label="Fecha Fin"
                type="date"
                value={vacacionForm.fechaFin}
                onChange={(e) => setVacacionForm({...vacacionForm, fechaFin: e.target.value})}
                InputLabelProps={{ shrink: true }}
            />
        </DialogContent>
        <DialogActions>
            <Button onClick={() => setAddVacacionDialog(false)}>Cancelar</Button>
            <Button onClick={handleSaveVacacion} color="primary">
                Guardar
            </Button>
        </DialogActions>
    </Dialog>
</div>
</div>
                </div>
                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Médico')}>
                            {editMedico ? 'Actualizar' : 'Guardar'}
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddMedico;


